import React from 'react';
import { DeploymentCard } from '../../atoms/deployment';

interface Deployment {
  id: string;
  name: string;
  environment: string;
  status: 'active' | 'inactive' | 'deploying';
  version: string;
  endpoint: string;
  traffic: string;
  lastDeployed: string;
  uptime: string;
  requestsPerMin: string;
}

interface EnvironmentsListProps {
  deployments: Deployment[];
  onSettings: (id: string) => void;
  onViewLogs: (id: string) => void;
}

export const EnvironmentsList: React.FC<EnvironmentsListProps> = ({
  deployments,
  onSettings,
  onViewLogs,
}) => {
  return (
    <div className="space-y-4">
      {deployments.map((deployment) => (
        <DeploymentCard
          key={deployment.id}
          name={deployment.name}
          environment={deployment.environment}
          status={deployment.status}
          version={deployment.version}
          endpoint={deployment.endpoint}
          traffic={deployment.traffic}
          lastDeployed={deployment.lastDeployed}
          uptime={deployment.uptime}
          requestsPerMin={deployment.requestsPerMin}
          onSettings={() => onSettings(deployment.id)}
          onViewLogs={() => onViewLogs(deployment.id)}
        />
      ))}
    </div>
  );
};
